import { cn } from '@mntn-dev/ui-utilities'

type FocusedLayoutProps = Readonly<{
  children?: React.ReactNode
  className?: string
}>

export const FocusedLayout = ({ children, className }: FocusedLayoutProps) => {
  return (
    <div className="min-h-screen w-screen">
      <div
        className={cn(
          'w-fit-clamped px-6 py-12 mx-auto flex flex-col items-center gap-8',
          className
        )}
      >
        {children}
      </div>
    </div>
  )
}

export * from './focused-layout-header.tsx'
export * from './focused-layout-main.tsx'
